import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

type Property = Record<string, string | boolean | object | undefined>;

const sendEvent = (label: string, property: Property) => SnowplowService.fireStructuredEvent({
    action: 'clicked',
    category: 'react_search',
    label,
    property,
});

const clickDirectionEvent = (property: Property) => {
    sendEvent('map_direction', property);
    amplitude.track('map_direction clicked', property);
};
const clickFilterEvent = (property: Property) => {
    sendEvent('map_filter', property);
    amplitude.track('map_filter clicked', property);
};
const clickPinEvent = (property: Property) => {
    sendEvent('map_pin', property);
    amplitude.track('map_pin clicked', property);
};
const clickResetEvent = (property: Property) => {
    sendEvent('map_reset', property);
    amplitude.track('map_reset clicked', property);
};

const events = {
    clickDirectionEvent,
    clickFilterEvent,
    clickPinEvent,
    clickResetEvent,
};

export default events;
